module.exports = __webpack_public_path__ + "static/media/Bugs.d8275b03.svg";